<template>
    <NormalProduct :curatedBox="curatedBox"/>
</template>

<script>
import NormalProduct from './product-normal.vue'


export default {
    components: {
        NormalProduct
    },
    props:{
        curatedBox: Object
    },
    computed:{
    },
    methods:{
    },
    beforeMount(){
    },
    mounted() {
    },
    destroy() {
    }
}
</script>

<style>
.product-desc ul li{
    list-style: initial;
}
</style>

<style>
 .back-button{
    font-size:1.5vw;
    line-height:1.5;
    letter-spacing:.08em;
    text-transform:uppercase;
    font-weight:700;
    color:#0f0c38;
    cursor:pointer;
    text-align: left;
    width: 100%;
    padding: 1% 5% 0;
}
.curated-boxes-page{
    display:flex;
    padding:0 5% 10%;
    justify-content:space-between;
    overflow-x:hidden
}
.curated-boxes-page button,.curated-boxes-page p,.curated-boxes-page span,.product-page button, .product-page p, .product-page span{
    color:#0f0c38;
    margin:0
}
.curated-boxes-images-container{
    display:flex;
    flex-direction:column;
    width:47.5%;
    padding-top:5%
}
.curated-boxes-images-container .main-image,.curated-boxes-main-container .end-buttons-container .happybox-button{
    width:100%
}
.curated-boxes-images-container .sub-images-container{
    width:100%;
    display:flex;
    flex-direction:row;
    gap:2%;
    margin-top:5%
}
.curated-boxes-images-container .sub-images-container .sub-image{
    width:20%;
    max-height:100%;
    flex-shrink:1;
    flex-grow:0;
    min-width:0;
    cursor:pointer
}
.curated-boxes-images-container .sub-images-container .sub-image img{
    width:100%;
    height:100%;
    object-fit:cover;
    object-position:center
}
.curated-boxes-main-container{
    width:47.5%;
    display:flex;
    flex-direction:column
}

.curated-boxes-images-container .main-title,
.curated-boxes-main-container .main-title,
.main-title-container .main-title{
    font-size:3vw;
    font-family: Karla, sans-serif;
    font-weight:bold;
    margin:5% 0% 0%;
    line-height:1.2;
}
.curated-boxes-main-container .box-qty-container{
display: flex;
flex-direction: column-reverse;
}

.main-title-container .box-qty-container{
    width:100%;
    display:flex;
    justify-content:space-between;
}
.curated-boxes-main-container .box-qty-container .box-qty-input-container,
.main-title-container .box-qty-container .box-qty-input-container{
    width:50%;
    display:flex;
    justify-content:flex-start;
}

.curated-boxes-main-container .box-qty-container .input-container
.main-title-container .box-qty-container .input-container{
    width: 100%;
}
.curated-boxes-main-container .box-qty-container .box-qty-input-container input,
.main-title-container .box-qty-container .box-qty-input-container input{
    background-color:#fff;
    border:1px solid #e4e4e7!important;
    box-shadow:0 1px 2px #1f2937 14;
    border-radius:4px!important;
    height:unset!important;
    padding:1% 2%!important;
    text-align:center;
    font-size:1.3vw;
    width:40%!important;
    line-height:1.5;
    -moz-appearance:textfield;
    color:#0f0c38
}
.curated-boxes-main-container .box-qty-container .box-qty-input-container input::-webkit-inner-spin-button,
.curated-boxes-main-container .box-qty-container .box-qty-input-container input::-webkit-outer-spin-button,
.main-title-container .box-qty-container .box-qty-input-container input::-webkit-inner-spin-button,
.main-title-container .box-qty-container .box-qty-input-container input::-webkit-outer-spin-button{
    -webkit-appearance:none;
    margin:0
}
.curated-boxes-main-container .box-qty-container .box-qty-input-container button,
.main-title-container .box-qty-container .box-qty-input-container button{
    background-color:#fff;
    border:1px solid #e4e4e7;
    box-shadow:0 1px 2px #1f2937 14;
    border-radius:4px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:2vw;
    padding:0 4%;
    line-height:0;
    margin:0 2%;
    color:#0f0c38;
    min-width: 25px;
}
.curated-boxes-main-container .box-qty-container .box-qty-input-container button:hover,
.main-title-container .box-qty-container .box-qty-input-container button:hover{
    background-color:#faf7fe
}
.curated-boxes-main-container .box-qty-container .box-qty-input-container button:disabled,
.main-title-container .box-qty-container .box-qty-input-container button:disabled{
    opacity:.6
}
.curated-boxes-main-container .separator{
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
    width:100%
}
.curated-boxes-main-container .separator .line-separator{
    height:0;
    border-top:1px solid #000;
    width:40%
}
.curated-boxes-main-container .separator .text{
    font-size:1.5vw!important;
    letter-spacing:1px;
    font-weight:700;
    color:#150131;
    margin-bottom:2px;
    position:relative;
    display:block;
    background:#fff;
    width:fit-content;
    padding:0 5%
}
.curated-boxes-main-container .end-buttons-container{
    width:100%;
    margin-top:5%
}
.tooltip[x-placement^=bottom] .tooltip-arrow,.tooltip[x-placement^=top] .tooltip-arrow{
    margin-bottom:0;
    border-left-color:transparent!important;
    border-right-color:transparent!important
}
.write-container{
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    width:100%;
}

.pick-card-container{
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    width:100%;
    padding-bottom: 5%;
}

.write-container .pick-card-header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    border-bottom: 1px solid lightgray;
}

.write-container .paid-card-header{
    width: 100%;
}

.write-container .paid-card-header .selection-container{
    width: 100%;
    display: flex;
    align-items: center;
    gap: 15px;
}

.write-container .paid-card-header .subtitle{
    font-size: 1.15vw;
    line-height: 1.2;
}

.cards-container{
    width: 100%;
    display: flex;
    overflow-x: hidden;
    gap: 5px;
    margin: unset;
    margin-top: 2%;
}

.card-container{
    width: 19%;
    flex-shrink: 0;
    cursor: pointer;
    position: relative;
    display: flex;
}

.card-container.selected{
    border: 2px solid #16A34A;
}

.card-container .main-image{
    width: 100%;
}

.write-container .write-header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.write-container .write-header .title, .write-container .pick-card-header .title, .write-container .paid-card-header .title{
    font-size: 1.5vw;
    font-family: Karla, sans-serif;
    font-weight: bold;
    margin: 2% 0;
    line-height: 1.2;
}
.write-container .form-container{
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    width:100%;
    border: 1px solid lightgray;
    padding: 2%;
    border-radius: 4px;
}
.write-container .form-container .red-alert, .write-container .pick-card-container .red-alert{
    color:red;
    font-size:1.2vw;
}
.write-container .from-container,.write-container .message-container{
    display:flex;
    flex-direction:column;
    width:100%
}
.write-container .from-container label,.write-container .message-container label{
    font-weight:700;
    color:#0f0c38;
    font-size:1vw
}

.write-container .message-container label{
    padding-top: 3%;
}
.write-container .from-container input{
    width:40%
}
.write-container .from-container .purple-span{
    padding: 2% 0%;
}

.write-container .purple-span{
    font-size: 1.15vw;
    line-height: 1.4;
    width: 90%;
}
.write-container .blank-card-container,.qty-wrapper .blank-card-container{
    display:flex;
    align-items:center;
    color: #A01ADB;
    margin: 1% 0;
    text-decoration: underline;
    font-size: 1.15vw;
}
.write-container textarea{
    width:90%;
    min-height:20vh
}
.write-container input,.write-container textarea{
    background:#fff!important;
    border:1px solid #e5e7eb!important;
    box-shadow:0 1px 2px rgba(31,41,55,.08)!important;
    border-radius:4px!important;
    color:#0f0c38;
    height:unset!important;
    font-size:1.2vw;
    accent-color:black
}
.write-container input:focus-visible,.write-container textarea:focus-visible{
    border:1px solid #e5e7eb!important;
    outline:0
}
.no-more .tooltip{
    display:block!important
}
.tooltip{
    display:none;
    z-index:10000
}
.tooltip .tooltip-inner{
    background:#000;
    color:#fff;
    border-radius:16px;
    padding:5px 10px 4px
}
.tooltip .tooltip-arrow{
    width:0;
    height:0;
    border-style:solid;
    position:absolute;
    margin:5px;
    border-color:#000;
    z-index:1
}
.tooltip[x-placement^=top]{
    margin-bottom:5px
}
.tooltip[x-placement^=top] .tooltip-arrow{
    border-width:5px 5px 0;
    border-bottom-color:transparent!important;
    bottom:-5px;
    left:calc(50% - 5px);
    margin-top:0
}
.tooltip[x-placement^=bottom]{
    margin-top:5px
}
.tooltip[x-placement^=bottom] .tooltip-arrow{
    border-width:0 5px 5px;
    border-top-color:transparent!important;
    top:-5px;
    left:calc(50% - 5px);
    margin-top:0
}
.tooltip[x-placement^=left] .tooltip-arrow,.tooltip[x-placement^=right] .tooltip-arrow{
    border-top-color:transparent!important;
    border-bottom-color:transparent!important;
    top:calc(50% - 5px);
    margin-left:0;
    margin-right:0
}
.tooltip[x-placement^=right]{
    margin-left:5px
}
.tooltip[x-placement^=right] .tooltip-arrow{
    border-width:5px 5px 5px 0;
    border-left-color:transparent!important;
    left:-5px
}
.tooltip[x-placement^=left]{
    margin-right:5px
}
.tooltip[x-placement^=left] .tooltip-arrow{
    border-width:5px 0 5px 5px;
    border-right-color:transparent!important;
    right:-5px
}
.tooltip.popover .popover-inner{
    background:#f9f9f9;
    color:#000;
    padding:24px;
    border-radius:5px;
    box-shadow:0 5px 30px rgba(0,0,0,.1)
}
.tooltip.popover .popover-arrow{
    border-color:#f9f9f9
}
.tooltip[aria-hidden=true]{
    visibility:hidden;
    opacity:0;
    transition:opacity .15s,visibility .15s
}
.tooltip[aria-hidden=false]{
    visibility:visible;
    opacity:1;
    transition:opacity .15s
}
.general-advice{
    font-size:1.3vw;
    padding-top:3%
}

    .product-page .products-container{
      width: 100%;
      display: flex;
      gap: 15px;
    }

    .product-page  .product-container{
      width: 23%;
      cursor: pointer;
    }

    .product-legend{
        font-size: 1.15vw;
        line-height: 1.2;
        margin-top: 5% !important;
        background-color: #f8fafd;
        padding: 5%;
    }

    .product-legend .title{
        font-weight: bold;
    }

    .product-legend .subcopy{
        display: flex;
        align-items: center;
        width: 100%;
        gap: 15px;
        margin-top: 3%;
    }

    .product-legend .subcopy img{
        width: 8%;
        margin-left: 2%;
    }
    
    .product-legend .subcopy span{
        width: 50%;
        font-size: 1vw;
        line-height: 1.4;
    }

    .product-legend .subcopy.box-wing img{
        width: 8%;
        max-height: 2.5vh;
    }

    .product-legend .subcopy.postcard span{
        width: 40%;
    }
  
    .product-page .product-container img{
      width: 100%;
    }
  
    .curated-footer .title{
      font-family: Karla;
      color: #0f0c38;
      font-size: 1vw;
      font-weight: 700;
      margin: unset;
      line-height: 1.2;
      margin-bottom: 3%;
    }
  
    .curated-footer .price{
      font-family: Karla;
      color: #0f0c38;
      font-size: 1vw;
      margin: unset;
      line-height: 1.2;
    }

    .curated-boxes-page .more-gifts{
        font-size: 2vw;
        width: 100%;
        padding: 0%;
    }

    .more-gifts{
        width: 100%;
        padding: 0% 10% 5%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #f7fafd;
    }

    .curated-boxes-page .more-gifts .main-title{
        font-size: 2.5vw;
        width: 100%;
        text-align: left;
        border-bottom: 1px solid #E8E1F2;
    }

    .more-gifts .main-title{
        font-size: 3vw;
        font-family: 'Karla',sans-serif;
        font-weight: Bold;
        margin: 3% 0;
        line-height: 1.2;
        color: #0f0c38;
    }

    .more-categories{
        width: 100%;
        padding: 5% 10%;
        background-color: #fff1e8;
        text-align: center;
    }

    .more-categories .main-title{
        font-size: 3vw;
        font-family: moret;
        font-weight: 300;
        margin: 3% 0;
        line-height: 1.2;
        color: #0f0c38;
        font-style: italic;
    }

    .more-categories .main-title span{
        font-style: normal;
    }

    .product-desc{
        line-height: 1.2;
        font-size: 1.15vw;
        margin: 2% 0% !important;
    }

    .product-desc p{
        margin: unset;
    }

    .green-check{
        position: absolute;
        top: 0;
        left: 0;
    }

    .more-categories .categories-container{
      width: 100%;
      display: flex;
      gap: 10px;
      margin-bottom: 5%;
      align-items: flex-start;
      justify-content: center;
    }

    .category-container{
      width: 10%;
      cursor: pointer;
    }

    .category-container img{
      width: 100%;
    }

    .category-container .title{
      font-size: 1vw;
      margin: unset;
    }

    .preorder-alert{
        font-size: 1.15vw;
        line-height: 1.4;
        width: 100%;
        padding: 2% 0%;
        text-align: center;
    }

    .min-alert{
        font-size: 1.15vw;
        margin-left: 1%;
        font-weight: bold;
    }

    .write-container .pick-card-header .arrows-container{
        display: flex;
        align-items: center;
        gap: 5%;
        min-width: 20%;
        justify-content: flex-start;
        width: 100%;
        flex: 1;
    }

    .write-container .pick-card-header .arrows-container img{
        cursor: pointer;
        height: 2vw;
    }

    .write-container .pick-card-header .arrows-container .r-arrow{
        transform: rotate(180deg);
    }

    .flicking-goc-collection {
        min-width: 100%;
    }
    .flicking-goc-collection .flicking-camera{
        gap: 2%;
        padding: 1% 0%;
    }

    .flicking-bs-collection {
        min-width: 100%;
        padding: 0% 5%;
    }

    .price-container{
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        font-size: 1.15vw;
        gap: 0 10px;
        margin-bottom: 1rem;
    }

    .qty-wrapper{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }

@media screen and (max-width:767px){
    .price-container{
        font-size: 3.5vw;
        text-align: left;
    }
    .back-button{
        font-size:4vw;
        padding-top: 5%;
        z-index:1;
        top:0;
        position: sticky;
        letter-spacing: 0;
    }

    .pick-card-container{
        padding-bottom: 2%;
    }

    .write-container .pick-card-header{
        border: unset;
    }
    .curated-boxes-page{
        margin-top:5%;
        flex-direction:column
    }

    .curated-boxes-images-container{
        padding-top: unset;
        width:100%
    }
    .curated-boxes-main-container{
        width:100%
    }
    .curated-boxes-images-container .main-title,
    .curated-boxes-main-container .main-title{
        font-size:7vw;
        text-align:center;
        margin-top:0%;
        margin-bottom:0;
        font-family: Founders Grotesk, sans-serif;
    }
    .curated-boxes-main-container .box-qty-container,
    .main-title-container .box-qty-container{
        justify-content:space-between;
        margin:5% 0;
        flex-direction:column-reverse;
        text-align:center;
        align-items: center;
        width: 100%;
    }

    .box-qty-container .price{
        font-size: 3.5vw;
        text-align: center;
        width: 100%;
    }
    .curated-boxes-main-container .box-qty-container .box-qty-input-container,
    .main-title-container .box-qty-container .box-qty-input-container{
        justify-content: center;
        width:100%
    }
    .curated-boxes-main-container .box-qty-container .box-qty-input-container input,
    .main-title-container .box-qty-container .box-qty-input-container input{
        font-size:4.5vw;
        width:20%!important
    }
    .curated-boxes-main-container .box-qty-container .box-qty-input-container button,
    .main-title-container .box-qty-container .box-qty-input-container button{
        font-size:5vw;
        padding:0 8%;
        line-height:1.3
    }
    .curated-boxes-main-container .separator .text{
        font-size:20px!important
    }
    .curated-boxes-main-container .product-tabs{
        margin:10% 0
    }
    .curated-boxes-main-container .product-tabs .tab-container button,.curated-boxes-main-container .product-tabs .tab-content .description-container p,.curated-boxes-main-container .product-tabs .tab-content .write-container .form-container .red-alert,.curated-boxes-main-container .product-tabs .tab-content .write-container .from-container label,.curated-boxes-main-container .product-tabs .tab-content .write-container .message-container label,.write-container .pick-card-container .red-alert,.write-container .form-container .red-alert{
        font-size:3.5vw
    }
    .curated-boxes-main-container .product-tabs .tab-content{
        max-height:60vh;
        overflow-y:scroll
    }
    .curated-boxes-main-container .product-tabs .tab-content .purple-span{
        font-size:3vw
    }
    .curated-boxes-main-container .product-tabs .tab-content .write-container .blank-card-container,.curated-boxes-main-container .product-tabs .tab-content .write-container input,.curated-boxes-main-container .product-tabs .tab-content .write-container textarea{
        font-size:4vw
    }
    .tooltip{
        font-size:5vw
    }
    .general-advice{
        font-size:4vw;
        text-align:center;
        padding-top:5%
    }

    .product-desc{
        font-size: 3.5vw;
    }

    .more-gifts .slick-slider{
        width: 100%;
    }

    .more-categories .main-title,.more-gifts .main-title,.curated-boxes-page .more-gifts .main-title{
        font-size: 6vw;
        text-align: center;
    }

    .write-container .pick-card-header .title, .write-container .write-header .title, .write-container .paid-card-header .title{
        font-size: 4vw;
        text-align: center;
        font-family: 'Karla';
        font-weight: bold;
    }

    .product-page .product-container{
        padding: 5%;
    }

    .write-container .blank-card-container,.write-container input,.write-container textarea,.qty-wrapper .blank-card-container{
        font-size: 3.5vw;
    }

    .category-container .title,.curated-footer .title,.curated-footer .price,.write-container .purple-span,.write-container .message-container label,.write-container .from-container label{
        font-size: 3vw;
    }

    .write-container .purple-span{
        width: 100%;
    }

    .preorder-alert{
        font-size: 3vw;
    }

    .write-container .paid-card-header .subtitle{
        font-size: 3.5vw;
    }

    .min-alert{
        font-size: 3.5vw;
        text-align: right;
    }

    .product-legend{
        padding: 5% 10%;
        background-color: #fffceb;
    }

    .product-legend .title{
        font-size: 4vw;
        font-weight: bold;
        width: 100%;
        text-align: center;
    }

    .product-legend .subcopy span{
        font-size: 3.5vw;
        width: 80%;
    }

    .product-legend .subcopy img{
        width: 10%
    }

    .product-legend .subcopy.box-wing img{
        width: 14%;
        margin-left: -2%;
        max-height: unset;
    }

    .product-legend .subcopy.postcard span{
        width: 65%;
    }

    .more-gifts{
        background-color: #fffceb;
        border: 1px solid #0f0c38;
    }

    .product-page .product-container .happybox-button{
        width: 100%;
        margin: 0.5rem 0;
    }

    .ad{
        margin: unset;
        padding: 1rem
    }

    .write-container .pick-card-header .arrows-container img{
      height: 3vh;
    }

    .qty-wrapper{
        flex-direction: column;
    }
}

 
</style>